import { SummaryProvider } from 'contexts/summary.context';
import CheckboxList from 'components/checkbox-list/checkbox-list';
import SummaryList from 'components/summary-list/summary-list';

const SummaryPage = () => {
  return (
    <SummaryProvider>
      <CheckboxList />
      <SummaryList />
    </SummaryProvider>
  );
};

export default SummaryPage;
